export const reviews = [
  {
    text: "This chocolate is a masterpiece! The velvety texture and rich cocoa aroma make it an unforgettable treat.",
    rating: 5
  },
  {
    text: "I was amazed by the balance of flavors. The dark chocolate with sea salt is sophisticated and perfectly executed.",
    rating: 5
  },
  {
    text: "Exceptional quality and fast delivery. The artisanal approach is evident in every single bite. Highly recommended!",
    rating: 5
  },
  {
    text: "The hazelnut collection is to die for. It's rare to find such high-quality ingredients at such a reasonable price.",
    rating: 4
  },
  {
    text: "As a chocolate connoisseur, I can say this is top-tier. The packaging is also very elegant and eco-friendly.",
    rating: 5
  },
  {
    text: "I bought a gift box for my mother, and she was delighted. The presentation is as exquisite as the taste itself.",
    rating: 5
  },
  {
    text: "Smooth, creamy, and absolutely delicious. It’s the perfect companion for my morning coffee.",
    rating: 4
  },
  {
    text: "You can really taste the difference in quality. No artificial aftertaste, just pure, high-grade chocolate bliss.",
    rating: 5
  },
  {
    text: "The variety of flavors is impressive. I particularly enjoyed the spicy chili chocolate—it's a bold and unique choice.",
    rating: 5
  },
  {
    text: "A truly premium experience from start to finish. This shop has definitely earned a loyal customer in me!",
    rating: 5
  }
];